import React from 'react';
import PropTypes from 'prop-types';
import styles from './DimensionsModal.module.css';
import TextInput from '../../ReusableComponents/TextInput/TextInput';
import isNumeric from '../../../Lib/Utils/Numeric/isNumeric';

export default function WeightInput({ unit, currentValue = 0, onChange }) {
  const error =
    currentValue !== null && currentValue !== undefined && currentValue <= 0;

  const handleChange = ({ target: { value } }) => {
    if (!value) {
      onChange(null);
      return;
    }
    if (value && value.length > 0 && isNumeric(value) === false) return;
    onChange(value);
  };

  return (
    <TextInput
      name={`${unit}_weight_field`}
      className={styles.rowItem}
      fullWidth
      value={
        currentValue === undefined || currentValue === null ? '' : currentValue
      }
      onChange={handleChange}
      autoComplete="no"
      endAdornment={<span className={styles.sizeEndAdornment}>{unit}</span>}
      formHelperText={
        error && (
          <span style={{ color: 'red' }}>
            The weight must be greater than 0
          </span>
        )
      }
      error={error}
    />
  );
}

WeightInput.propTypes = {
  unit: PropTypes.string.isRequired,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};
